// Операції з .zip архівом: додавання вкладень, зображень та завантаження файлу.

// Додає вкладення тікету (логи та інші матеріали) у папку files, зі збереженням порядку додавання
function addAttachmentsToZip(zip, attachments){
    if(attachments.length === 0){
        return;
    }
    let filesFolder = zip.folder("files");
    for(let file of attachments){
        if(file.data != null){
            filesFolder.file(file.archivedName, file.data);
        }
    }
}

// Додає зображення (з опису та чату) у папку images.
// base64-зображення додаються напряму, звичайні посилання - довантажуються через fetch.
async function addImagesToZip(zip, images){
    if(images.length === 0){
        return;
    }
    let imgFolder = zip.folder("images");
    await Promise.all(images.map(async (img) => {
        try {
            if(img.dataUri){
                imgFolder.file(img.filename, img.dataUri.base64, { base64: true });
            } else {
                let response = await fetch(img.src);
                let blob = await response.blob();
                imgFolder.file(img.filename, blob);
            }
        } catch (error) {
            console.error("[exportTicket] не вдалося завантажити зображення:", img.src, error);
        }
    }));
}

// Завантажує blob як файл у браузері
function downloadBlob(blob, filename){
    let url = URL.createObjectURL(blob);
    let downloadLink = document.createElement("a");
    downloadLink.href = url;
    downloadLink.download = filename;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    URL.revokeObjectURL(url);
}

export { addAttachmentsToZip, addImagesToZip, downloadBlob };
